"use strict";

exports.__esModule = true;
exports.SelectDefaultCommentFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _API = require("../../API");
var _Core = require("../../Core");
var _DashboardCollection = require("../../Dashboard/DashboardCollection");
var _reactIntl = require("react-intl");
var _DefaultCommentSelector = require("../DefaultCommentSelector/DefaultCommentSelector");
var _PredefinedCommentsContext = require("../../PredefinedComments/PredefinedCommentsContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectDefaultCommentFields = exports.SelectDefaultCommentFields = function SelectDefaultCommentFields(props) {
  var config = props.config,
    onChange = props.onChange;
  var defaultCommentID = config.defaultCommentID;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_PredefinedCommentsContext.PredefinedCommentsContext),
    defaultComments = _React$useContext2.settings.defaultComments;
  var selectedComment = defaultComments.find(function (defaultComment) {
    return defaultComment._id === defaultCommentID;
  });
  var handleCommentSelect = function handleCommentSelect(selected) {
    onChange(Object.assign({}, config, {
      defaultCommentID: selected.length > 0 ? selected[0]._id : undefined
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_DashboardCollection.DashboardCollection, null, function (collection) {
    return /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
      collection: collection
    }, function (searcherProps) {
      return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, searcherProps, function () {
        var selected = selectedComment ? [selectedComment] : [];
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, defaultComments && (defaultComments == null ? void 0 : defaultComments.length) !== 0 && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "SelectDefaultCommentFields.predefinedComment.label",
            defaultMessage: translate("PlantStateActivityEditor.predefinedComment.label", "Predefined comment")
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "SelectDefaultCommentFields.predefinedComment.helperText",
            defaultMessage: translate("PlantStateActivityEditor.predefinedComment.helperText", "Predefined comment to use")
          })
        }, /*#__PURE__*/_react["default"].createElement(_DefaultCommentSelector.DefaultCommentSelector, {
          items: defaultComments,
          selected: selected,
          toggle: true,
          onSelect: handleCommentSelect
        })));
      });
    });
  });
};